"use strict";
/**
 * @module Tiers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTiersList = void 0;
var getTiersList_1 = require("./getTiersList");
Object.defineProperty(exports, "getTiersList", { enumerable: true, get: function () { return getTiersList_1.getTiersList; } });
